export const BEST_OFFERS_SUBMENU = 'best-offers-sub-menu';
export const BEST_OFFERS_SUB_HEADLINE = 'best-offers-sub-menu-headline';
export const BEST_OFFERS_SUB_LINK = 'best-offers-sub-menu-link';

export const BEST_OFFERS_SUBMENU_MOBILE = 'best-offers-sub-menu-mobile';
